import { Box, Typography } from '@material-ui/core'
import * as Sentry from '@sentry/react'

import Button from '@/components/button'
import Card from '@/components/card'

const ErrorFallback: Sentry.FallbackRender = ({ error, resetError }) => {
  return (
    <Box
      height='98vh'
      display='flex'
      alignItems='center'
      justifyContent='center'
    >
      <Card>
        <Typography>Algo deu errado:</Typography>
        <pre style={{ whiteSpace: 'pre-wrap' }}>
          {error instanceof Error ? error.message : error}
        </pre>
        <Button labelOnly onClick={resetError}>
          Tente novamente!
        </Button>
      </Card>
    </Box>
  )
}

export const ErrorBoundary: React.FC = ({ children }) => {
  return (
    <Sentry.ErrorBoundary fallback={ErrorFallback}>
      {children}
    </Sentry.ErrorBoundary>
  )
}
